export default {
  id: 'ActivityLog',
  code: 'CN',
  text: {
    'Principal': '校长',

    // operation
    'created': '创建了',
    'edited': '编辑了',
    'deleted': '删除了',
    'closed': '关闭了',
    'added': '加入了',
    'accepted': '接受了',
    'denied': '拒绝了',
    'published': '发布了',
    'unpublished': '下架了',
    'recovered': '恢复了',
    'invited': '邀请了',
    'transfered': '转化了',
    'removed': '退班了',  
    'archived': '转移了',
    'imported': '导入了',
    // object_type
    'teacher': '老师',
    'student': '学生',
    'class': '班级',
    'private class': '私课',
    'contact notes': '联系人备忘',
    'invitation': '学校邀请',
    'student custom fields': '学员自定义字段',
    'contact custom fields': '联系人自定义字段',
    'terms and conditions': '注册条款',
    'recorded a charge': '记录了一笔学生收款',
    'recorded a refund': '记录了一笔学生退款',
    'initiated a charge': '发起了一笔学生收款',
    'initiated a refund': '发起了一笔学生退款',
    'planning task': '时间规划事项',
    'lesson': '课节',
    'lessons': '课节',
    'school': '学校',
    'poster': '海报',
    'permissions': '权限',
    'permission group': '权限组',
    'transaction remark with the receipt number': '交易备注 收据号',
    'contact tag': '联系人标签',
    'contact': '联系人',
    'announcement': '公告',
    'classroom': '教室',
    'students': '学生',
    'poster attendee': '海报报名人',
    '{name} {operation} {object_type} ': '{name}{operation}{object_type}：',
    '{name} {operation} student {studentName} to {object_type}: ' : '{name}将学生{studentName}{operation}{object_type}：',
    '{name} {operation} multiple students to {object_type}: ' : '{name}将多个学生{operation}{object_type}：',

    '{name} {operation} {object_type} for ' : '{name}{operation}一个{object_type}，联系人',
    '{name} {operation} {object_type}' : '{name}{operation}{object_type}',

    '{name} {operation} for {belong_to_type} ': '{name}{operation}：{belong_to_type}',

    '{name} {operation} {object_type} {object_name} {connecting_word} {belong_to_type} ': '{name}{operation}{object_type} {object_name} 给{belong_to_type}：',
    '{name} {operation} multple {object_type} {connecting_word} {belong_to_type} ': '{name}{operation}多个{object_type}给{belong_to_type}：',

    "'s member": '的成员',
    
    '{name} {operation} multiple {object_type} ': '{name}{operation}多个{object_type}',
    '{name} {operation} {object_type} {object_name} from {target_type} {target_name}': '{name}将{object_type}{object_name}从{target_type}{target_name}里{operation}',


    // specifictly for operation archive, can't think of a better way to do it 
    '{object_name} {operation} {object_type} ': '{object_name}{operation}{object_type}到历史{object_type}：',
    '{object_name} {operation} multiple {object_type}': '{object_name}{operation}多个{object_type}到历史{object_type}',

  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Fields/ActivityLog/locale.js